import AppDownloadButtons from "../components/shared/app-download-buttons";
import Card from "../components/shared/card";
import Typography from "../components/shared/typography";

const DownloadAppPage = () => {
  return (
    <div className="min-h-screen lg:h-screen flex flex-col lg:flex-row bg-cream-600">
      {/* Left: Hero Image */}
      <div className="relative w-full h-[60vh] sm:h-[70vh] lg:h-screen lg:flex-1 order-2 lg:order-1 mt-4 lg:mt-0">
        <img
          src="/images/app-home-screen.png"
          alt="Harper iOS App"
          className="absolute inset-0 w-full h-full object-contain lg:object-cover"
        />
        <div className="absolute inset-0 bg-transparent"></div>
      </div>

      {/* Right: Download Card */}
      <div className="relative z-10 w-full lg:flex-1 flex items-start lg:items-center justify-center p-4 pt-24 lg:pt-0 order-1 lg:order-2">
        <Card
          className="w-full max-w-md shadow-xl"
          variant="cream"
          elevation={3}
        >
          <Card.Header variant="cream" className="text-center">
            <Typography variant="h3" className="text-terracotta mb-4">
              Download the Harper App
            </Typography>
          </Card.Header>
          <Card.Body>
            <div className="text-center space-y-4 w-full">
              <Typography className="text-gray-700 w-full">
                To continue, please download the Harper mobile app.
              </Typography>
              <Typography className="text-gray-700 w-full">
                If you signed up with your phone number, log in using your phone
                number in the app to access your account.
              </Typography>
              <AppDownloadButtons />
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default DownloadAppPage;
